/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { EvironmentConfig } from "./environment-config";
import "zone.js/plugins/zone-error"; // Included with Angular CLI.

export const environment: EvironmentConfig = {
  enableProdMode: true,
  environmentKey: "dev",
  // The dev API's vanity host (the old anvilor-surveys-dev-02 azurewebsites
  // host was decommissioned and no longer resolves — submissions failed).
  apiBase: "https://api-dev.anvilor.com/api",
  configApiBase: "https://form-configs-dev.anvilor.com",
};
